import { ModalActions } from '@ui-kit/components/Modal/Modal';
import { useTranslation } from 'react-i18next';
import MailCheckIcon from '@/components/icons/MailCheckIcon';
import type { ContactVerificationSuccessPayload } from '@/components/ModalRenderer/components/SE/contactVerificationSuccess';
import useOnContactVerificationSuccess from '@/components/ModalRenderer/components/SE/useOnContactVerificationSuccess';
import type { ModalProps } from '@/components/ModalRenderer/components/types';
import { Modal } from '@/components/ModalRenderer/Modal';
import Button from '@/ui-kit/components/Button/Button';

type Payload = ContactVerificationSuccessPayload;

const EmailVerificationSuccess = ({ closeModal, payload: { successAction } }: ModalProps<Payload>) => {
  const { t } = useTranslation('Modal', { keyPrefix: 'EmailVerificationSuccess' });
  const handleSuccessAction = useOnContactVerificationSuccess(successAction);

  const handleContinue = () => {
    closeModal();
    handleSuccessAction();
  };

  return (
    <Modal title="">
      <div className="-mt-2 mb-6 flex flex-col items-center text-center">
        <MailCheckIcon className="text-icon-brand mb-4 size-12" aria-hidden="true" />
        <h2 className="text-heading mb-2 lg:text-center">{t('title')}</h2>
        <p className="text-text-subtle">{t('info')}</p>
      </div>
      <ModalActions>
        <Button onClick={handleContinue}>{t('button')}</Button>
      </ModalActions>
    </Modal>
  );
};

export default EmailVerificationSuccess;
